export const handleChange = (e, setState) => {
	setState(e.target.value);
};
export const transportDefaultColors = ["#4cc9f0", "#1023b3", "#b31e1e"];
